<template>
 <div class="introduction">
   <div class="introduction-header">
     <div id="introductionText"></div>
   </div>
   <div>
   <img class="clogo" src="../assets/images/clogo.png">
   </div>
   <img class="interdictioncontent" src="https://enited-static-resources.oss-accelerate.aliyuncs.com/static/1621686561692_.pic.jpg">
   <div class="qrcode">
     <div class="code">
      <div class="ios"></div>
      <div class="android"></div>
     </div>
   </div>
 </div>
</template>

<script>
import * as echarts from 'echarts'
import {onMounted,watch} from 'vue'
import { useRouter } from "vue-router";
export default {
  name: 'INTRODUCTION',
  props: {
  },
  setup(){
    const router = useRouter();
    const intChart = () =>{

    }
    onMounted(()=>{
      // const command_edom = document.getElementById("command");
      // command_edom.removeAttribute("_echarts_instance_");
      const domMap = document.getElementById("introductionText");
      domMap.removeAttribute("_echarts_instance_");

              console.log('改变11111')
        let myChart2 = null
      myChart2 = echarts.init(document.getElementById("introductionText"));

      myChart2.setOption({})
      myChart2.resize();
      var option = {
    graphic: {
    elements: [
      {
        type: 'text',
        left: 'center',
        top: 'center',
        style: {
          font: 'bold 0.36rem "pingfang"',
          text: '新一代数字营销利器',
          lineDash: [0, 100],
          lineDashOffset: 10,
          fill: 'transparent',
          stroke: '#000',
          lineWidth: 0.5
        },
        keyframeAnimation: {
          duration: 1000,
          loop: false,
          keyframes: [
            {
              percent: 0.7,
              style: {
                fill: 'transparent',
                lineDashOffset: 200,
                lineDash: [200, 0]
              }
            },
            {
              percent: 0.8,
              style: {
                fill: 'transparent'
              }
            },
            {
              percent: 1,
              style: {
                fill: '#2d2d2d'
              }
            }
          ]
        }
      }
    ]
  }
      };
      myChart2.setOption(option)
      myChart2.resize();
       window.onresize =  ()=> {
        myChart2.resize();
      };
           watch(
      () => router.currentRoute.value,
      (newValue) => {
        console.log('重置111')
        myChart2.resize();
      },
      { immediate: true }
    );
    })
  
   
  }
}
</script>
<style lang="scss" scoped>
.user{
    font-family: pingfangM;
}
.introduction-header{
  width: 100%;
  height: 4.1rem;
  position: relative;
  background: url('https://enited-static-resources.oss-accelerate.aliyuncs.com/static/1631686561700_.pic.jpg');
  background-size: 100% 100%;
  text-align: center;
  .introduction-title{
    font-size: 0.4rem;
    line-height: 4.5rem;
    font-family: pingfangB;
    color: black;
  }
  img{
    width: 100%;
    height: 90%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
}

.clogo{
  width: 1.8rem;
  height: 0.5rem;
  margin-top: 0.2rem;
}
.interdictioncontent{
  width: 6.5rem;
  margin-top: 0.6rem;
  height: 3rem;
}
.ios{
  width: 0.8rem;
  height: 0.8rem;
  background: url("../assets/images/ioscode.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 50px;
  border: 3px solid black;
}
.android{
  width: 0.8rem;
  height: 0.8rem;
  background: url("../assets/images/androidcode.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 50px;
  border: 3px solid black;
}
.qrcode{
  width: 100%;
  margin: 0.4rem auto;
  display: flex;
  .code{
    margin: 0 auto;
    text-align: center;
    display: flex;
  }
}
#introductionText{
  position: absolute;
  left: 0;
  right: 0;
  top: 1.5rem;
  margin: auto;
   width: 50%;
  height: 200px;
  z-index: 40 !important;
}
</style>
